export enum CbhFeatureFlag {
  WORKPLACE_REFERRALS = "2023-10-facilitate-rollout-workplace-referrals",
  HOME_HEALTH_ENABLED = "2024-01-home-health-HCF-HHA-enabled",
  INVOICE_HISTORY_REVAMP = "2024-02-alchemy-release-invoice-history-revamp",
  HOME_HEALTH_PAY_RATES = "2024-03-home-health-default-pay-rates-per-visit-type",
  INVOICE_DISPUTE_PAGE = "2024-03-alchemy-release-invoice-dispute-page",
  STREAKS_PRE_REWARD = "2024-03-core-services-streaks-pre-rewards",
}
